import React from "react";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrophone } from "@duocards/pro-regular-svg-icons";
import { getTheme } from "styled/theme";
import useSpeechTapHold from "hooks/useSpeechTapHold";
import Loader from "components/other/Loader";
import { InputIconButton } from "components/assistant/AssistantComponents";

const Wrap = styled.div`
  user-select: none; // fix selection on iphone when long press on microphone icon
`;

type Props = {
  onTranscription: (text: string) => void;
  languages?: string[];
  disabled?: boolean;
  className?: string;
};

const SpeechToText: React.FC<Props> = ({ onTranscription, languages, disabled, className }) => {
  const { transcribing, listening, supported, handlers, globalRecording, otherRecording } = useSpeechTapHold({
    onTranscription,
    languages,
    stopAfterMs: 30000,
    forceMp3: true
  });

  if (!supported) return null;

  return (
    <Wrap className={className}>
      <InputIconButton
        {...handlers}
        disabled={otherRecording || disabled || transcribing}
        size="medium"
        data-recording-arrow="hide"
      >
        {transcribing ? (
          <Loader size={30} color={getTheme().palette.white} />
        ) : (
          <FontAwesomeIcon
            icon={faMicrophone}
            color={getTheme().palette.white}
            fade={globalRecording ? listening : false}
          />
        )}
      </InputIconButton>
    </Wrap>
  );
};

export default SpeechToText;
